import { render, staticRenderFns } from "./PrimaryContactAutocomplete.vue?vue&type=template&id=25962ca2"
import script from "./PrimaryContactAutocomplete.vue?vue&type=script&lang=js"
export * from "./PrimaryContactAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports